import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  makeStyles,
  StylesProvider,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import React from "react";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Img from "react-cool-img";
import earn from "../../../assets/staticAssets/earn_2.svg";
import EmailCapture from "../../EmailCapture/index";

function LandingPageTwelfthSection() {
  const theme = useTheme();
  const small = useMediaQuery(theme.breakpoints.down("sm"));
  const classes = useStyles();

  return (
    <div className=" pb-20 md:mb-0 -mt-10 bg-gradient-to-b from-[#131517] to-[#1A1C21] relative">
      <Img
        src={
          require("../../../assets/optimized/Landing/Call to Action (Last Section)/candlestick patterns.svg")
            .default
        }
        className="absolute w-full  md:-top-24 -top-10"
      ></Img>

      {/* <Img
        src={
          require("../../../assets/optimized/Landing/Footer/footerWaves.svg")
            .default
        }
        className="absolute w-[1000px]"
      ></Img> */}

      <div className="container-bt">
        <div className="">
          <div className="flex items-center flex-col">
            {" "}
            <div className={`${classes.bottomBar} px-2  z-10`}>
              <h1 className="mb-5">Start trading now</h1>{" "}
              <div className="flex justify-center ">
                <EmailCapture></EmailCapture>
              </div>
              <p className="opacity-50 mb-3 mt-6">
                The future of money is just an email away!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  bottomBar: {
    marginTop: "100px",
    textAlign: "center",
    padding: "40px 0px",
    background:
      "radial-gradient(98.09% 98.09% at 31.51% 23.05%, rgba(75, 80, 94, 0.7) 0%, rgba(36, 38, 43, 0.7) 100%)",
    width: "95%",

    borderRadius: "25px",
    WebkitBackdropFilter: "blur(5px)",
    backdropFilter: "blur(5px)",
  },
}));
export default LandingPageTwelfthSection;
